import { adminCheck, schoolCheck, tourCompanyCheck } from './guards'

export default [
  {
    path: '/',
    name: 'Login',
    component: () => import('@/components/functions/Auth/PgLogin')
  },
  {
    path: '/Register/:user',
    name: 'Register',
    component: () => import('@/components/functions/Auth/PgRegister')
  },
  {
    path: '/ResetPassword/',
    name: 'ResetPassword',
    component: () => import('@/components/functions/Auth/ResetPassword')
  },
  {
    path: '/Admin/User',
    name: 'AdminUser',
    component: () => import(/* webpackChunkName: "admin" */ '@/components/functions/Admin/M0001User/M0001AdminUserIndex'),
    beforeEnter: adminCheck,
    meta: { requiresAuth: true }
  },
  {
    path: '/Admin/Bidding',
    name: 'AdminBidding',
    component: () => import(/* webpackChunkName: "admin" */ '@/components/functions/Admin/M0301Bidding/M0301AdminBiddingIndex'),
    beforeEnter: adminCheck,
    meta: { requiresAuth: true }
  },
  {
    path: '/Admin/BiddingGuide',
    name: 'AdminBiddingGuide',
    component: () => import(/* webpackChunkName: "admin" */ '@/components/functions/Admin/M0303BiddingGuide/M0303AdminBiddingGuideIndex'),
    beforeEnter: adminCheck,
    meta: { requiresAuth: true }
  },
  {
    path: '/School/User',
    name: 'SchoolUser',
    component: () => import(/* webpackChunkName: "school" */ '@/components/functions/School/M0001User/M0001SchoolUserIndex'),
    beforeEnter: schoolCheck,
    meta: { requiresAuth: true }
  },
  {
    path: '/School/Bidding',
    name: 'SchoolBidding',
    component: () => import(/* webpackChunkName: "school" */ '@/components/functions/School/M0301Bidding/M0301SchoolBiddingIndex'),
    beforeEnter: schoolCheck,
    meta: { requiresAuth: true }
  },
  {
    path: '/TourCompany/User',
    name: 'TourCompanyUser',
    component: () => import(/* webpackChunkName: "tourCompany" */ '@/components/functions/TourCompany/M0001User/M0001TourCompanyUserIndex'),
    beforeEnter: tourCompanyCheck,
    meta: { requiresAuth: true }
  },
  {
    path: '/TourCompany/Bidding',
    name: 'TourCompanyBidding',
    component: () => import(/* webpackChunkName: "tourCompany" */ '@/components/functions/TourCompany/M0301Bidding/M0301TourCompanyBiddingIndex'),
    beforeEnter: tourCompanyCheck,
    meta: { requiresAuth: true }
  },
  {
    path: '*',
    redirect: '/'
  }
]
